<template>
  <div class="">
    <hr>
    <div class="my-2">
      <span class="badge badge-pill mx-2 badge-warning text-capitalize">{{ item.type }}</span>
      <span class="badge badge-pill mx-2 badge-warning text-capitalize">شناسه: {{ item.id }}</span>
      <div class="form-group d-inline-block">
        <input :id="`secure-${item.id}`" type="checkbox" v-model="item.security">
        <label :for="`secure-${item.id}`" class="mx-2 d-inline-block">محافظت شده</label>
      </div>
    </div>
    <div class="form-group">
      <input type="text" class="mb-2 form-control" v-model="item.title">
    </div>


    <div class="form-group mx-3 d-inline-block">
      <input :id="`item-1-${item.id}`" type="checkbox" v-model="item.config.verify_with_sms">
      <label :for="`item-1-${item.id}`" class="mx-2">امضای از طریق تایید شماره تلفن</label>
    </div>

    <div class="form-group mx-3 d-inline-block">
      <input :id="`item-2-${item.id}`" type="checkbox" v-model="item.config.digital_sign_handwrite">
      <label :for="`item-2-${item.id}`" class="mx-2">امضا دیجیتال</label>
    </div>

    <div class="form-group mx-3 d-inline-block">
      <input :id="`item-3-${item.id}`" type="checkbox" v-model="item.config.digital_sign_image">
      <label :for="`item-3-${item.id}`" class="mx-2">عکس امضا</label>
    </div>




    <b-icon class="bg-danger d-inline p-1 rounded-pill mx-2 h3 text-white d-block my-2" icon="trash"
            @click="deleteQuestion()"/>
  </div>
</template>

<script>
import {generateHash} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart";

export default {
  name: "TextareaInput",
  props: {
    item: {}
  },
  computed: {
    generateHashComputed() {
      return generateHash()
    }
  },
  methods: {
    deleteQuestion() {
      this.$emit('removeQuestion')
    }
  }
}
</script>

<style scoped>

</style>